module.exports = __webpack_public_path__ + "img/aquila-logo.8942c978.png";